import { useBreakpoints } from '@uds/responsive';
import { Suspense, lazy } from 'react';

import { StickyCheckoutProps } from './components/types';

const StickyMobile = lazy(() => import('./components/StickyCheckout.mobile'));
const StickyDesktop = lazy(() => import('./components/StickyCheckout.desktop'));

interface Props extends StickyCheckoutProps {}

export default function StickyCheckoutContainer(props: Readonly<Props>): JSX.Element {
  const { isMinMd } = useBreakpoints();
  return (
    <Suspense fallback={<div data-testid="sticky-loader" />}>
      {isMinMd ? <StickyDesktop {...props} /> : <StickyMobile {...props} />}
    </Suspense>
  );
}
